import React, { useEffect, useState } from "react";
import axios from "axios";

function ResetPassword({ currentUser }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);

  // Fetch all users once
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const res = await axios.get("https://crm-server-htk6.vercel.app/api/users");
        setUsers(res.data);
      } catch (err) {
        console.error("❌ Error fetching users:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  // Filter users based on currentUser role + center
  useEffect(() => {
    if (!currentUser) return;

    let allowed = users;

    if (currentUser.role === "SuperAdmin") {
      // Can see *all* users in the same center
      allowed = users.filter((u) => u.center === currentUser.center);
    } else if (currentUser.role === "Admin") {
      // Admin can only see Agent + Verifier in same center
      allowed = users.filter(
        (u) =>
          u.center === currentUser.center &&
          ["Agent", "Verifier"].includes(u.role)
      );
    } else {
      // Other roles cannot reset anyone
      allowed = [];
    }

    // Apply firstName search filter
    if (searchTerm.trim()) {
      allowed = allowed.filter((u) =>
        u.firstName.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredUsers(allowed);
  }, [users, currentUser, searchTerm]);

  // Reset password → firstName
  const handleResetPassword = async (user) => {
    try {
      const newPassword = user.firstName;
      const payload = { ...user, password: newPassword };
      delete payload._id;

      const res = await axios.put(
        `https://crm-server-htk6.vercel.app/api/users/${user._id}`,
        payload
      );

      if (res.data.success) {
        alert(`✅ Password reset for ${user.firstName} ${user.lastName}`);
        setUsers((prev) =>
          prev.map((u) =>
            u._id === user._id ? { ...u, password: newPassword } : u
          )
        );
      }
    } catch (err) {
      console.error("❌ Error resetting password:", err);
      alert("Failed to reset password");
    }
  };

  if (!currentUser) {
    return <p>⚠️ Current user not found. Please log in.</p>;
  }

  return (
    <div className="page">
      <h2>Reset Password</h2>

      {/* Filter Bar */}
      <div className="filter-bar" style={{ marginBottom: "15px" }}>
        <input
          type="text"
          placeholder="Search by First Name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button onClick={() => setSearchTerm(searchTerm)}>Go</button>
      </div>

      <div className="table-container">
        {loading ? (
          <p>Loading users...</p>
        ) : (
          <table className="user-table">
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Role</th>
                <th>Center</th>
                <th>Emp Code</th>
                <th>Password</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.length === 0 ? (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    No Users Found
                  </td>
                </tr>
              ) : (
                filteredUsers.map((u) => (
                  <tr key={u._id}>
                    <td>{u.firstName}</td>
                    <td>{u.lastName}</td>
                    <td>{u.role}</td>
                    <td>{u.center}</td>
                    <td>{u.empCode}</td>
                    <td>{u.password}</td>
                    <td>
                      <button
                        className="btn transfer"
                        onClick={() => handleResetPassword(u)}
                      >
                        Reset
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
